import {
  buildFacebookPdpAttributes,
} from '@/shared/features/analytics/utils/facebookCommonAttributes';
import { commonFacebookEventsUtilWithServerAttribution } from '@/shared/features/analytics/utils/facebookServerEventAttribution';
import type { ProductDetail } from '../../domain/models/ProductDetail';
import type { PdpEffectiveProductVm } from '../viewModels/pdp.vm';

export function facebookViewContent(
  product: ProductDetail,
  vm: PdpEffectiveProductVm,
  selectedSizeDisplay?: string,
): void {
  commonFacebookEventsUtilWithServerAttribution(
    'ViewContent',
    buildFacebookPdpAttributes(product, vm, selectedSizeDisplay),
  );
}
